/**
 * Piggy pig-face mark (work-in-progress logo), reproduced as inline SVG from the
 * brand glyph so it stays crisp at any size and needs no asset hosting.
 */
export function PigMark({ size = 28, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={(size * 56) / 66}
      viewBox="0 0 66 56"
      className={className}
      role="img"
      aria-label="Piggy"
    >
      {/* ears */}
      <path d="M 8 22 L 14 4 L 26 18 Z" fill="#f7b4b4" />
      <path d="M 58 22 L 52 4 L 40 18 Z" fill="#f7b4b4" />
      {/* face */}
      <ellipse cx="33" cy="30" rx="26" ry="22" fill="#fac6c6" />
      {/* eyes */}
      <circle cx="22" cy="24" r="2.4" fill="#1a0d0d" />
      <circle cx="44" cy="24" r="2.4" fill="#1a0d0d" />
      {/* snout */}
      <ellipse cx="33" cy="37" rx="13" ry="9" fill="#ea9c9c" />
      <ellipse cx="28" cy="37" rx="2" ry="3.5" fill="#1a0d0d" />
      <ellipse cx="38" cy="37" rx="2" ry="3.5" fill="#1a0d0d" />
    </svg>
  );
}

/** Logo + wordmark lockup used in the header. */
export function Logo({ size = 30 }: { size?: number }) {
  return (
    <span className="flex items-center gap-2.5">
      <span className="grid place-items-center rounded-xl bg-brand-soft p-1.5">
        <PigMark size={size} />
      </span>
      <span className="flex items-baseline gap-1.5 font-extrabold tracking-tight text-ink">
        <span className="text-[1.15rem] leading-none">Piggy</span>
        <span className="rounded-md bg-brand/10 px-1.5 py-0.5 text-[0.7rem] font-bold uppercase tracking-wide text-brand-strong">
          Shop
        </span>
      </span>
    </span>
  );
}
